<template>
    <section>
        <div class="container">
                <h2>회원 탈퇴하기</h2>
                <hr>
            <div class="container">
                <h4>탈퇴 사유</h4>
                <br>
                <div class="form-group input-group">
                    <div>
                        <input name="exitReason" type="radio" id="exitReason1" value="다른 사용자명으로 사용하기 위해서" @click="readonlyOn" v-model="member.withdrawReason">
                        <label for="exitReason1" @click="textReadonly=true"> &nbsp;다른 사용자명으로 사용하기 위해서</label>
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <input name="exitReason" type="radio" id="exitReason2" value="사용빈도가 낮고, 개인정보 유출이 우려되서" @click="readonlyOn" v-model="member.withdrawReason">
                        <label for="exitReason2" @click="textReadonly=true"> &nbsp;사용빈도가 낮고, 개인정보 유출이 우려되서</label>
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <input name="exitReason" type="radio" id="exitReason3" value="서비스의 질에 대한 불만이 있어서" @click="readonlyOn" v-model="member.withdrawReason">
                        <label for="exitReason3" @click="textReadonly=true"> &nbsp;서비스의 질에 대한 불만이 있어서</label>
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <input name="exitReason" type="radio" id="exitReason4" value="사이트 이용시 고객응대가 나빠서" @click="readonlyOn" v-model="member.withdrawReason">
                        <label for="exitReason4" @click="textReadonly=true"> &nbsp;사이트 이용시 고객응대가 나빠서</label>
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <input name="exitReason" type="radio" id="exitReason5" @click="setFocus()" value="기타사유" v-model="member.withdrawReason">
                        <label for="exitReason5" @click="setFocus()"> &nbsp;기타사유</label>
                        <input type="text" class="form-control col-12" ref="anotherReason" id="reasonText" v-model="withdrawReasonText" v-bind:readonly="textReadonly">
                    </div>
                </div>
                <br>
                <div class="form-group input-group">
                    <div>
                        <p>비밀번호 확인</p>

                        <input type="password" class="form-control" ref="password" v-model="member.password" >
                    </div>
                </div>
                <div class="container text-center">
                    <button class="btn btn-outline-primary my-5" @click="$router.go(-1)" style="margin-right: 10px">돌아가기</button>
                    <button class="btn btn-outline-primary my-5" @click="WithdrawMsg">회원 탈퇴하기</button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    export default {
        name: 'withdraw',
        components: {
        },
        data() {
            return {
                member:{
                    id : 0,
                    isWithdraw: false,
                    withdrawReason : '',
                    password:process.env.NODE_ENV == 'development' ? "11111111": ""
                },
                withdrawReasonText: "",
                textReadonly : true,
            };
        },
        methods: {
            setFocus(){
                this.textReadonly = false;
                this.$refs.anotherReason.focus()
            },
            WithdrawMsg () {
                if (this.withdrawReasonText != '')
                    this.member.withdrawReason = this.withdrawReasonText;

                if(this.member.password == '') {
                    this.checkPasswordRemind();
                }
/*
                if(this.$auth.user().roleNames.includes('ADMIN')) {
                    alert('관리자는 권한을 회수해야 탈퇴가 가능합니다.');
                    return false;
                }
*/
                this.$modal.show('dialog', {
                    text: `카라두잉 회원 탈퇴 시<br> <font color="red">모든 봉사활동 내역 및 활동 정보</font>가 사라집니다.<br> 정말 탈퇴하시겠습니까?`,
                    buttons: [
                        {
                            title: '탈퇴',
                            handler: () => {
                                this.WithdrawUser();
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
            WithdrawUser() {

                this.member.isWithdraw = true;

                let me = this;
                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/withdraw`, this.member)
                    .then(function (res) {
                        let result = res.data;
                        if(result) {
                            me.$root.$children[0].commonDialog('회원탈퇴','탈퇴 되었습니다. 이용해주셔서 감사합니다.');
                            me.$auth.logout()
                            me.$router.push('/')
                        }
                        else {
                            me.checkPasswordRemind();
                        }
                        //me.$auth.logout();
                    }).catch(function (error) {
                        me.$root.$children[0].commonDialog('회원탈퇴','탈퇴 실패. 재시도해주세요.');
                        console.log(error);
                });
            },
            checkPasswordRemind() {
                this.member.password = '';
                this.$root.$children[0].commonDialog('회원탈퇴','비밀번호를 확인해주세요.');
                this.$refs.password.focus();
                return;
            },
            readonlyOn(){
                this.textReadonly=true;
                this.withdrawReasonText=''
            }
        },
        computed: {},
        mounted() {
            this.member.isWithdraw = true;
            this.member.id = this.$auth.user().id;
        }
    };
</script>
<style scoped>
    hr{border-top: 3px solid #0077ff;}
</style>